import LegalPage from '@/components/legal/LegalPage';

export default function Cookies() {
  return (
    <LegalPage
      title="Cookie Policy"
      intro="How Quick Credit uses cookies and similar technologies on this website."
      sections={[
        {
          heading: 'What cookies are',
          body: <p>Cookies are small text files placed on your device when you visit a website. They help the site function and help us understand how it is used.</p>,
        },
        {
          heading: 'Strictly necessary cookies',
          body: <p>These keep you signed in, protect against fraud, secure form submissions and remember your session. The site cannot work correctly without them.</p>,
        },
        {
          heading: 'Performance and analytics cookies',
          body: <p>These help us measure page performance and understand which pages are useful, so we can improve speed and usability. The data is aggregated.</p>,
        },
        {
          heading: 'Advertising cookies',
          body: <p>Where used, these measure the effectiveness of our advertising campaigns, including Google Ads conversion tracking. They may be set by third-party advertising partners.</p>,
        },
        {
          heading: 'Managing cookies',
          body: <p>You can block or delete cookies through your browser settings at any time. Blocking strictly necessary cookies may prevent parts of the site, including the application form, from working.</p>,
        },
      ]}
    />
  );
}
